import { createReducer, on } from '@ngrx/store';
import { initialHeadProductDetailsStore } from './head-product-details.store';
import { HeadProductDetailsActions } from './head-product-details.actions';

export const headProductDetailsReducer = createReducer(
  initialHeadProductDetailsStore,

  // ==================== GET HEAD PRODUCT BY ID ====================

  on(HeadProductDetailsActions.getHeadProductSuccess, (state, { response }) => {
    // Auto-populate filter values from first product (if available)
    const firstProduct = response.products && response.products.length > 0 ? response.products[0] : null;

    return {
      ...state,
      ...response,
      error: null,
      selectedDimension: firstProduct?.dimension || null,
      selectedOption1: firstProduct?.option_1 || null,
      selectedOption2: firstProduct?.option_2 || null,
      selectedOption3: firstProduct?.option_3 || null,
    };
  }),

  on(HeadProductDetailsActions.getHeadProductFailure, (state, { error }) => ({
    ...state,
    error
  })),

  // ==================== FILTER ACTIONS ====================

  on(HeadProductDetailsActions.setSelectedDimension, (state, { dimension }) => ({
    ...state,
    selectedDimension: dimension
  })),

  on(HeadProductDetailsActions.setSelectedOption1, (state, { option1 }) => ({
    ...state,
    selectedOption1: option1
  })),

  on(HeadProductDetailsActions.setSelectedOption2, (state, { option2 }) => ({
    ...state,
    selectedOption2: option2
  })),

  on(HeadProductDetailsActions.setSelectedOption3, (state, { option3 }) => ({
    ...state,
    selectedOption3: option3
  })),

);
